import { TKey } from '~/src/dash/publicaUI';

export enum EDashboardSection {
  Overview = 1,
  Live,
  ParentOverview,
  AuctionInsights,
  PublicaAnalytics,
}

type DashboardSectionLabel =
  | 'Overview'
  | 'Live'
  | 'Parent Overview'
  | 'Auction Insights'
  | 'Publica Analytics';

export interface IDashboardSection {
  label: DashboardSectionLabel;
  value: EDashboardSection;
  isParentPublisherOnly?: boolean;
  isPublicaOnly?: boolean;
  isSuperUserOnly?: boolean;
  isPublicaExcluded?: boolean;
  tKey?: TKey;
}

export interface IDashboardsConfig {
  defaultState: {
    section: number;
  };
  sections: IDashboardSection[];
}

const dashboardSections: IDashboardSection[] = [
  { label: 'Overview', value: EDashboardSection.Overview, tKey: 'Overview' },
  { label: 'Live', value: EDashboardSection.Live, tKey: 'Live' },
  {
    label: 'Parent Overview',
    value: EDashboardSection.ParentOverview,
    isParentPublisherOnly: true,
  },
  {
    label: 'Auction Insights',
    value: EDashboardSection.AuctionInsights,
    tKey: 'AuctionInsights',
    isSuperUserOnly: true,
    isPublicaExcluded: true,
  },
  { label: 'Publica Analytics', value: EDashboardSection.PublicaAnalytics, isPublicaOnly: true },
];

export const dashboardsConfig: IDashboardsConfig = {
  defaultState: {
    section: EDashboardSection.Overview,
  },
  sections: dashboardSections,
};

export const findDashboardSectionByValue = (value: EDashboardSection) => {
  return dashboardSections.find((section) => value === section.value) || dashboardSections[0];
};
